import { render, staticRenderFns } from "./participants-list.vue?vue&type=template&id=4c2eb67f"
import script from "./participants-list.vue?vue&type=script&lang=js"
export * from "./participants-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports